import { db } from '../config/constants';

export const updatePlayerType = (teamId, uid, type) =>
  db.doc(`teams/${teamId}/roster/${uid}`).update({ type });
